export default __webpack_public_path__ + "static/media/IndiaSoft2025-Skyniche 3 1-7.3e1829ef.png";